// Utilities for validation

export function isNotEmpty(value: any): boolean {
  if (value === null || value === undefined || value === '') {
    return false
  }
  return true
}

export function isEmpty(value: any): boolean {
  if (value === null || value === undefined || value === '') {
    return true
  }
  return false
}

export function stringToBoolean(input: string): boolean {
  return input === 'true'
}

export const parseBooleanQueryParam = (param: string | null): boolean => {
  return param === 'true'
}
